import { EntityModel } from '@/interfaces'
import {
  ALL_CAPACITY_SETTINGS_QUERY,
  CREATE_CAPACITY_SETTINGS_MUTATION,
  DELETE_CAPACITY_SETTINGS_MUTATION,
  FORCE_DELETE_CAPACITY_SETTINGS_MUTATION,
  SINGLE_CAPACITY_SETTINGS_QUERY,
  UPDATE_CAPACITY_SETTINGS_MUTATION,
} from './graphql'
import accommodationAgeGroupCapacityEntity from '@/entities/accommodationAgeGroupCapacity/entity'
import accommodationAgeGroupedTotalCapacityEntity from '@/entities/accommodationAgeGroupedTotalCapacity/entity'
import travelPricingAgeGroupEntity from '@/entities/travelPricingAgeGroup/entity'

const accommodationCapacitySettingsModel: EntityModel = {
  name: 'capacitySettings',
  namePlural: 'capacitySettings',
  uniqueName: 'accommodationCapacitySettings',
  uniqueNamePlural: 'accommodationCapacitySettings',
  path: 'travel/pricing/accommodation/capacity_settings',
  baseUrl: '/travel/pricing/accommodation/capacity_settings',
  translationPrefix: 'entities:accommodationCapacitySettings.',
  getDisplayName: (values: any) => {
    return 'Capacity Settings'
  },
  gql: {
    getAll: ALL_CAPACITY_SETTINGS_QUERY,
    getSingle: SINGLE_CAPACITY_SETTINGS_QUERY,
    create: CREATE_CAPACITY_SETTINGS_MUTATION,
    update: UPDATE_CAPACITY_SETTINGS_MUTATION,
    delete: DELETE_CAPACITY_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_CAPACITY_SETTINGS_MUTATION,
  },
  attributes: {
    totalCapacity: {
      name: 'totalCapacity',
      label: 'entities:accommodationCapacitySettings.attributes.totalCapacity.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    rangesAllowed: {
      name: 'rangesAllowed',
      label: 'entities:accommodationCapacitySettings.attributes.rangesAllowed.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    ageGroupCapacities: {
      name: 'ageGroupCapacities',
      label: 'entities:accommodationCapacitySettings.attributes.ageGroupCapacities.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return accommodationAgeGroupCapacityEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    ageGroupedTotalCapacities: {
      name: 'ageGroupedTotalCapacities',
      label: 'entities:accommodationCapacitySettings.attributes.ageGroupedTotalCapacities.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return accommodationAgeGroupedTotalCapacityEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    partialOccupancyAllowed: {
      name: 'partialOccupancyAllowed',
      label: 'entities:accommodationCapacitySettings.attributes.partialOccupancyAllowed.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    partialOccupancyAllowedAgeGroups: {
      name: 'partialOccupancyAllowedAgeGroups',
      label: 'entities:accommodationCapacitySettings.attributes.partialOccupancyAllowedAgeGroups.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelPricingAgeGroupEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default accommodationCapacitySettingsModel
